export default "__VITE_ASSET__Cj5N6M2U__"